<template>
  <div>
    <NavbarComponent />
    <HeroSection  />
    <FeaturesSection />
    <BoardMembersSection />
    <!-- <ServicesSection /> -->
    <NewsletterSection />
    <FooterComponent />
  </div>
</template>

<script>
import NavbarComponent from '@/components/home/NavbarComponent.vue';
import HeroSection from '@/components/home/HeroSection.vue';
import FeaturesSection from '@/components/home/FeaturesSection.vue';
import BoardMembersSection from '@/components/home/BoardMembersSection.vue';
import ServicesSection from '@/components/home/ServicesSection.vue';
import NewsletterSection from '@/components/home/NewsletterSection.vue';
import FooterComponent from '@/components/home/FooterComponent.vue';

export default {
  components: {
    NavbarComponent,
    HeroSection,
    FeaturesSection,
    BoardMembersSection,
    ServicesSection,
    NewsletterSection,
    FooterComponent
  }
};
</script>

<style>
/* Global styles if needed */
html {
  scroll-behavior: smooth;
}



</style>
